import {Box} from '@mui/material';
import React from 'react';

import {useHostName} from 'presentation/hooks';
import {ProductLogoProps} from './types';

export function ProductLogo({
	invertColor,
	customHeight = 32,
	customWidth,
	invertPlanTypeColor,
	isMobile,
	...boxProps
}: ProductLogoProps) {
	const {dataHostNameState} = useHostName();

	return (
		<Box {...boxProps}>
			{dataHostNameState.productLogo({
				height: customHeight,
				width: customWidth,
				invertColor,
				invertPlanTypeColor,
				isMobile,
			})}
		</Box>
	);
}
